import Service from "../Service";

const baseURL = Service.defaults.baseURL;
const resource = baseURL + "GenGenericType/";

export default {
    getUrlSearchArea() {
        return resource + "area-search";
    },

    getUrlSearchPosition() {
        return resource + "position-search";
    },

    getUrlDefinition() {
        return resource + "definition-search";
    },

    getUrlSearchWorker() {
        return resource + "worker-search";
    },

    getUrlSearchCeco() {
        return resource + "ceco";
    },

    getUrlSearchGf() {
        return resource + "gf";
    },

    getUrlSearchAccount() {
        return resource + "account";
    },
    acoGetUrlSearchPeriod() {
        return resource + "aco-period";
    },

    genGetUrlSearchSupplier() {
        return resource + "gen-supplier";
    },


    exportExcel(request) {
        return Service.post(resource + "export-excel", request, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: {}
        })
    },


};